import PropTypes from "prop-types";
import ResponsiveImage from "utils/contentful/ResponsiveImage";
import { assetUrl } from "utils";
import styled from "styled-components";

const StyledOrderItem = styled.div`
  .img-container {
    width: 70px;
    height: 70px;
    flex-shrink: 0;
    border-radius: 9px;
    border: ${(props) =>
      props["$isGift"] ? "1px solid rgba(0, 0, 0, 0.2)" : "none"};
    overflow: hidden;
    position: relative;
    box-sizing: content-box;

    .img {
      width: 100%;
      height: auto;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

/**
 * Individual order item to be displayed in the order summary.
 *
 * @param {Object} props
 * @param {Object} props.item
 */
const CheckoutOrderItem = ({ item }) => {
  const { image, name, cost, description, isGift } = item;

  return (
    <StyledOrderItem className="flex items-center py-2" $isGift={isGift}>
      <div className={"img-container mr-4 flex items-center"}>
        {image ? (
          <ResponsiveImage
            sizes={"70px"}
            source={{
              url: image.file?.url,
              thumbnailSizes: [70, 140, 210],
            }}
            quality={100}
          />
        ) : (
          <img
            src={assetUrl("/static/img/order-item-img.png")}
            width={80}
            height={80}
          />
        )}
      </div>
      <div className="details flex justify-between flex-grow">
        <div className={"pr-4"}>
          <div className="font-medium text-black text-sm">{name}</div>
          <div className="text-textGray-lighter text-sm">{description}</div>
        </div>
        <div className="text-black text-sm">{cost}</div>
      </div>
    </StyledOrderItem>
  );
};

CheckoutOrderItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    image: PropTypes.object.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      .isRequired,
    cost: PropTypes.string.isRequired,
    isGift: PropTypes.bool,
  }),
};

export default CheckoutOrderItem;
